import { render, staticRenderFns } from "./AgeRequirement.vue?vue&type=template&id=6e4f6cfe&"
import script from "./AgeRequirement.vue?vue&type=script&lang=js&"
export * from "./AgeRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports